module.exports = __webpack_public_path__ + "img/logo-white.157989cd.svg";